<div class="form-checkbox">
    <mat-radio-group aria-label="Select an option" [(ngModel)]="dateModel"  (ngModelChange)="onSelectionChange($event)">
        <label class="input-label"> {{labelText}} </label>
        <mat-radio-button class="radio-button" value="false">{{optionOne}}</mat-radio-button>
        <mat-radio-button class="radio-button"  value="true">{{optionTwo}}</mat-radio-button>
    </mat-radio-group>
</div>